import axios from "axios";
import Swal from "sweetalert2";

export default {
  methods: {
    showHistDate(date) {
      return this.dateToLocalString(date);
    },

    clearFilesSelection() {
      this.csvFile = "";
      this.showMappingPanel = false;
    },
    checkEmpty()
    {
     //debugger
      for(let i = 0 ; i < this.selectedFields.length;i++ )
      {
        if(Array.isArray(this.selectedFields[i]))
        {
        this.selectedFields.splice(i);
        }
      }
    },
   async finalizeButtonPressed() {
      let out = [];
        for (let i = 1; i < 5; i++) {
     
          if (this.selectedFields[i].columnHeading == "") {
            this.$toast.add({ severity: 'error', summary: 'Error Message', detail: 'Missing Mandatory Fields [First Name, Last Name, Date of Birth, Gender]', life: 3000 });
             return;
       
          }
        }
      Swal.fire({
        icon: "warning",
        title: "Confirmation",
        text: "Are you sure you want to upload selected file.",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00c292",
        confirmButtonText: "Upload",
      }).then((result) => {
        if (result.value) {
          this.intDummyComm();
          this.intDummyComm.myDate = this.dateToSqlServerDateFormat(new Date());

          const url =
            this.SERVER + "/VNSPRAAPI/Patient/UploadPatients";
          this.fileDataString
          
          console.log(this.uploadHistoryList);
          this.newList = {
            createdAt: this.intDummyComm.myDate,
            createdBy: localStorage.getItem("UserName"),
            errorFile: "No-Error",
            errorFileUrl: "No-Error",
            myProperty: null,
            skippedRows: 0,
            totalRows: "-",
            uploadedFile: this.csvFile.name,
            uploadedFileUrl: "",
            uploadedRows: "-"
          };
          this.uploadHistoryList.unshift(this.newList);
         //debugger
          this.checkEmpty();
          let formData = new FormData();
          formData.append('csvFile', this.csvFile);
          formData.append('dc', JSON.stringify(this.dummyComm));
          formData.append('columnheaders', JSON.stringify(this.selectedFields));
          this.$toast.add({ severity: 'info', summary: 'Uploading', detail: 'Your upload has started. Once completed you will be notify via email.', life: 5000 });

          try {
            axios.post(url,
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  Authorization: this.$store.getters.getAuthToken,
                }
              }
            ).then(res => {
              if (res.data.dc.auditFlag < 0) {

                this.$toast.add({ severity: 'error', summary: 'Error Message', detail: 'Unable to save data. ' + res.dc.auditFlagVal, life: 3000 });
              } else {
                this.uploadHistoryList = res.data.hist;
                this.totalrows = res.data.count;
                this.showMappingPanel = false;
                this.showFileUpload = false;
                this.loadInit();
                // this.$toast.add({ severity: 'success', summary: 'Success Message', detail: 'Data saved successfully.', life: 3000 });
              }
            });
          } catch {/**/ }
          finally {
            this.showMappingPanel = false;
            this.showFileUpload = false;
          }
        }
      });


    },

    fieldExistInSelectedList(arr) {
     //debugger
      for (let k = 0; k < arr.length; k++) {
        let found = false;
        const val = arr[k];
        for (let i = 0; i < this.selectedFields.length; i++) {
          if (this.selectedFields[i].dbColumn == val) { found = true; break; }
        }
        if (!found) return false;
      }
      return true;
    },

    getSampleFieldText(ndx) {
      try {
        return this.firstLine[ndx];
      } catch { return ""; }
    },

    fileUploader($e) {
     //debugger
      if (this.fileUploadKount > 2) {
        this.fileUploadKount = 1;
      }

      const reader = new FileReader();
      reader.readAsText($e.files[0]);

      reader.onload = () => {
        let self = this;
        self.fileDataString = reader.result;
        self.aaa = reader.result;
      };

      let arr = this.fileDataString.split('\r\n');
      this.fileHeaderFields = arr[0].split(',');
      this.fileUploadKount++;
      this.csvFile = $e.files[0];

      try {
        var csv = require('jquery-csv');
        let abc = $.csv.toArrays(this.fileDataString);
        this.zeroline = abc[0];
        this.firstLine = abc[1];
        // let sf = [];
        // const zl = abc[0];
        // const fl = abc[1];
        // const pf = this.patientFields;
        // this.firstLine = [];
        // this.zeroline = [];
        // //let found=false;
        // for (let i = 0; i < pf.length; i++) {
        //   for (let j = 0; i < zl.length; j++) {
        //     if (pf[i].name.toLowerCase() == zl[j].toLowerCase()) {
        //       this.zeroline.push(zl[j]);
        //       this.firstLine.push(fl[j]);
        //       break;
        //     }
        //   }
        // }


      }
      catch (err) {
        console.log(csv);
        console.log(err);
        this.firstLine = [];
        for (let i = 0; i < this.fileHeaderFields.length; i++)
          this.firstLine.push("");
      }
    },

    autoFillMappingDropdowns() {
     //debugger
      if (this.fileDataString.length < 1 || this.fileHeaderFields.length < 1) {
        this.ShowErrorAutoClose("Invalid Input.");
        return;
      } else {
        //-- first make dropdown object
        this.fileHeaderFieldsObj = [];
        let out = this.fileHeaderFieldsObj;

        for (let i = 0; i < this.patientFields.length; i++) {
          let obj = {
            columnHeading: this.patientFields[i].name + "",
            dbColumn: this.patientFields[i].dbColumn,
          };
          out.push(obj);
        }

        //-- auto map if match
       //debugger
        for (let i = 0; i < this.zeroline.length; i++) {
          let obj = {
            columnHeading: "",
            dbColumn: "",
          };

          this.selectedFields[i] = JSON.parse(JSON.stringify(obj));
         //debugger
          for (let j = 0; j < this.patientFields.length; j++) {

            if (this.zeroline[i].trim().toLowerCase() == this.patientFields[j].name.toLowerCase()) {
             // alert(this.zeroline[i].trim().toLowerCase()+ "==" +this.patientFields[j].name.toLowerCase())
              try {
                const a = this.fileHeaderFieldsObj[i].dbColumn;
                const b  = this.fileHeaderFieldsObj[i].columnHeading;

                this.fileHeaderFieldsObj[i].dbColumn = this.patientFields[j].dbColumn;
                this.fileHeaderFieldsObj[i].columnHeading = this.patientFields[j].name;
                this.selectedFields[i] = JSON.parse(JSON.stringify(this.fileHeaderFieldsObj[i]));
                
                this.fileHeaderFieldsObj[i].dbColumn = a;
                this.fileHeaderFieldsObj[i].columnHeading = b;

                break;
              } catch { console.log('ok'); }
            }
          }
        }
        
        for (let i=0; i< this.patientFields.length; i++) {
          let found = false;
          for (let j=0; j<this.fileHeaderFieldsObj.length; j++) {
            if (this.patientFields[i].name == this.fileHeaderFieldsObj[j].columnHeading) {
              found = true;
              break;
            }
          }

          if(!found) {
            let xyz = {
              columnHeading: this.patientFields[i].name,
              dbColumn: "",
            };
            // this.fileHeaderFieldsObj.push(xyz);
          }
        }

      }
    },

    //timer set
    StartLogoutTime() {
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
    ResetLogoutTime() {
      clearTimeout(this.TimerObject);
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
    
    showGoButton() {
      if (this.selectedUploadType !== "") return true;
      else return false;
    },

    goButtonPressed() {
      this.showFileUpload = !this.showFileUpload;
    },

    async onPage(e) {
      this.intDummyComm();

      this.dummyComm.extras = "";
      this.dummyComm.pageNumber = e.page + 1;
      this.dummyComm.pageSize = e.rows;
      this.pagerows = e.rows;

      this.loading = true;
      const url = this.SERVER + "/VNSPRAAPI/Patient/GetUploadHistoryList";
      await this.axiosGetData(url, this.dummyComm, 1);
      this.loading = false;
    },

    async loadInit() {
      this.intDummyComm();
      this.dummyComm.extras = "";
      this.dummyComm.pageNumber = 0;
      this.dummyComm.pageSize = this.pagerows;

      this.loading = true;
      const url = this.SERVER + "/VNSPRAAPI/Patient/GetUploadHistoryList";
      await this.axiosGetData(url, this.dummyComm, 1);
      this.loading = false;
      this.StartLogoutTime();
    },

    async axiosGetData(myUrl, myData, what) {
      await axios({
        method: "post",
        url: myUrl,
        data: myData,
        headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          if (what === 1) {
            this.uploadHistoryList = res.data.hist;
            this.totalrows = res.data.count;
            this.showMappingPanel = false;
            this.showFileUpload = false;
          }
        })
        .catch(function (error) {
          if (error.response) {
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            alert("No response " + error.request);
          } else {
            alert("Error", error.message);
          }
        })
        .finally(() => {
          //this.ResetLogoutTime();
          this.showMappingPanel = false;
          this.showFileUpload = false;
        });
    }, // axiosGetData
  }, // methods

  mounted() {
    if(this.$store.getters.getAuthToken==="")
    {
        this.$store.commit('setAuthToken',localStorage.BeToken);
    }
    clearTimeout(this.loadObj);
    const arr = [];
    for (let i = 0; i < this.patientFields.length; i++) {
      this.selectedFields.push(arr);
    }
    this.loadInit();
  },
  unmounted() {
    clearTimeout(this.TimerObject);
  },
  watch: {
    fileUploadKount: function (val) {
      this.showMappingPanel = val > 2 ? true : false;
      if (this.showMappingPanel)
        this.autoFillMappingDropdowns();
    }
  }, // watch
}